export default "__VITE_ASSET__01ddd491__"